module.exports = __webpack_public_path__ + "img/Bear39.3ebab032.jpg";